import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { FormPage } from "../../../common/components/form_page";
import { CardFormation } from "../../../common/components/card/formation";
import { Specialties } from "../../../common/components/controls/select/specialties";
import { Grades } from "../../../common/components/controls/select/grades";
import { Colleges } from "../../../common/components/controls/select/colleges";
import { InfoText } from "../../../common/components/info_text";
import { Item, ListItems } from "../../../common/components/list_items";
import { FormationSituation } from "../../../common/components/controls/select/formation-situation";
import { useUser } from "../../../common/hooks/User";
import { textChooser } from "../../../common/util/textChooser";
import { createUserFormation } from "../../../common/apis/private.api";
import { ButtonAdd } from "../../../common/components/controls/button/buttonAdd";

interface AcademicsProps { }

export const Academics = (props: AcademicsProps) => {
  const client = useQueryClient();
  const { getDataAll, refreshUserSession } = useUser();
  const { formationInfo, id } = getDataAll();

  const { register, handleSubmit, reset } = useForm();

  const { mutate, isLoading, isError, isSuccess } = useMutation((param: any) =>
    createUserFormation(param.id, param.data)
  )

  const handleOnSubmit = (e: any) => {
    mutate({ id, data: { formations: [{ ...e, situation: parseInt(e.situation) }] } });
    client.invalidateQueries(['validate-profile'])
  }

  useEffect(() => {
    if (isSuccess) {
      refreshUserSession();
      reset();
    }
  }, [isSuccess]);

  const buttonLabel = isLoading ? textChooser("txt140") : formationInfo.length ? textChooser("txt211") : textChooser("txt217")

  return (
    <FormPage pageTitle={textChooser("txt109")} pageDescription={textChooser("txt110")}>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <Specialties hook={{ ...register("career", { required: true }) }} />
          </div>
          <div className="col-md-6 col-sm-12">
            <Grades hook={{ ...register("type", { required: true }) }} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <Colleges hook={{ ...register("college", { required: true }) }} />
          </div>
          <div className="col-md-6 col-sm-12">
            <FormationSituation hook={{ ...register("situation", { required: true }) }} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <InfoText
              text={textChooser("txt141")}
              type="danger"
              hidden={!isError}
            />
          </div>
          <div className="col-xs-12" style={{ marginTop: "15px" }}>
            <ButtonAdd
              type="submit"
              label={buttonLabel}
              disabled={isLoading}
            />
          </div>
        </div>
      </form>

      <ListItems>
        {formationInfo.map((formation) =>
          <Item key={formation.id}>
            <CardFormation
              {...formation}
              careerId={formation.id}
              userId={id}
            />
          </Item>
        )}
      </ListItems>
    </FormPage>
  )
}